import {TranslocoService} from '@ngneat/transloco';
import {PropertiesErrorsInterface} from '../../../shared/csv-validation/properties-errors.interface';

export class TriggerPropertiesErrors implements PropertiesErrorsInterface{

  private triggerPropertiesErrors: { [key: string]: string };

  constructor(private readonly i18n: TranslocoService) {
    this.i18n.selectTranslation().subscribe((): void => {
      this.triggerPropertiesErrors = {
        name: this.i18n.translate('info.importTriggersCsv.fields.name'),
        entityType: this.i18n.translate('info.importTriggersCsv.fields.entityType'),
        entityIdentifier: this.i18n.translate('info.importTriggersCsv.fields.entityIdentifier'),
        sensorName: this.i18n.translate('info.importTriggersCsv.fields.sensorName'),
        operation: this.i18n.translate('info.importTriggersCsv.fields.operation'),
        value: this.i18n.translate('info.importTriggersCsv.fields.value'),
      };
    });
  }

  public getTranslation(property: any): string | null {
    return this.triggerPropertiesErrors.hasOwnProperty(property) ? this.triggerPropertiesErrors[property] : null;
  }
}
